import type { ReactNode } from "react";
import { MeterBar } from "../../components/MeterBar.js";
import { StatIcon } from "../../components/StatIcon.js";
import { StatHelpButton } from "./StatHelpButton.js";
import type { StatHelpTopic } from "./statHelp.js";

type CaseSurvivalRowProps = {
  fatigue: number;
  fatigueMax?: number;
  fatigueValue: ReactNode;
  blockValue: ReactNode;
  from?: number;
  onHelp: (topic: StatHelpTopic) => void;
};

export function CaseSurvivalRow({
  fatigue,
  fatigueMax = 10,
  fatigueValue,
  blockValue,
  from,
  onHelp,
}: CaseSurvivalRowProps) {
  return (
    <div className="progress-block is-fatigue">
      <div className="progress-label">
        <span className="meter-label">
          <StatIcon name="fatigue" />
          疲労
          <StatHelpButton topic="fatigue" onHelp={onHelp} />
        </span>
        <span className="meter-end">{fatigueValue} / {fatigueMax}</span>
      </div>
      <MeterBar
        key={from == null ? "bar" : `fill-${from}-${fatigue}`}
        value={fatigue}
        max={fatigueMax}
        from={from}
        variant="hp"
      />
      <div className="progress-label is-block">
        <span className="meter-label">
          <StatIcon name="block" />
          防御
          <StatHelpButton topic="block" onHelp={onHelp} />
        </span>
        <span className="meter-end">{blockValue}</span>
      </div>
    </div>
  );
}
